export const filterTypes = {
  HOURLY: '0',
  DAILY: '1',
  WEEKLY: '2',
  MONTHLY: '6'
};
